import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import {TmsCikisYerService} from "../ctl-tms-cikis-yer.service";

@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private tmsCikisYerService : TmsCikisYerService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
            dataSource.select([
            ]);

            const filterArr = [];
            if (this.tmsCikisYerService.belediyeCode) filterArr.push(['BelediyeKod', '=', this.tmsCikisYerService.belediyeCode]);
            if (filterArr.length > 0) dataSource.filter(filterArr);
            return dataSource;
    }

}
